import { TranslationKeys } from '@/localization';
import { FC, PropsWithChildren } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

type PageBigTitleProps = {
  title: TranslationKeys;
  subtitle: TranslationKeys;
  classNames?: {
    wrapper?: string;
    title?: string;
  };
} & PropsWithChildren;

export const PageBigTitle: FC<PageBigTitleProps> = ({ title, subtitle, classNames, children }) => {
  const { t } = useTranslation();

  return (
    <header className={twMerge('grid gap-5', classNames?.wrapper)}>
      <h2 className={twMerge('text-pretty text-6xl font-semibold tracking-[-0.075rem] first-letter:capitalize', classNames?.title)}>
        <Trans
          i18nKey={title as any}
          components={{
            blueWord: <span className='text-brand-600'></span>,
            newLine: <br />,
          }}
        />
      </h2>
      <div className='flex items-center gap-1.5'>
        <p className='first-letter:capitalize'>{t(subtitle as any)}</p>
        {children}
      </div>
    </header>
  );
};
